const jsonParse = (string) => {
  try {
    return JSON.parse(string);
  } catch (error) {
    return string;
  }
};

export default jsonParse;
